import { Icon } from '@pairy/pds-react';
import { useRouter } from 'next/router';
import { useState, useEffect, useRef, MouseEvent } from 'react';
import { useAtomValue } from 'jotai';

import { isDisableHelpersAtom } from '../../../../../../store/index.atom';

import * as Styled from './index.styles';

const LOCALE_NAMES: Record<string, string> = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-CN': '中文(简体)',
  'zh-TW': '中文(繁體)',
  'zh-HK': '中文(香港)',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  ru: 'Русский',
  hi: 'हिन्दी',
  id: 'Indonesia',
  ms: 'Melayu',
  th: 'ภาษาไทย',
  tr: 'Türkçe',
  vi: 'Tiếng Việt',
};

const MobileLanguageButton = () => {
  const router = useRouter();
  const isDisableHelpers = useAtomValue(isDisableHelpersAtom);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const locales = router.locales ?? [];
  const currentLocale = router.locale ?? 'ko';

  useEffect(() => {
    const handleClickOutside = (e: globalThis.MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isDisableHelpers) {
      setIsOpen(false);
    }
  }, [isDisableHelpers]);

  const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isDisableHelpers) {
      return;
    }
    setIsOpen((prev) => !prev);
  };

  const handleLocaleSelect = (
    e: MouseEvent<HTMLButtonElement>,
    locale: string,
  ) => {
    e.stopPropagation();
    const basePath = router.asPath;
    const newPath =
      locale === router.defaultLocale ? basePath : `/${locale}${basePath}`;
    window.location.href = newPath;
    setIsOpen(false);
  };

  return (
    <Styled.Wrapper ref={wrapperRef}>
      <Styled.Button
        // className={isDisableHelpers ? 'disable' : ''}
        variant="zinc_500"
        radius={9999}
        onClick={handleButtonClick}
        leftIcon={<Icon icon="ph:globe" size={19} color="black" />}
      />

      {isOpen && (
        <Styled.Dropdown direction="column" gap={2}>
          {locales.map((locale) => (
            <Styled.LanguageItem
              key={locale}
              isActive={locale === currentLocale}
              onClick={(e) => handleLocaleSelect(e, locale)}
            >
              {LOCALE_NAMES[locale] ?? locale}
            </Styled.LanguageItem>
          ))}
        </Styled.Dropdown>
      )}
    </Styled.Wrapper>
  );
};

export default MobileLanguageButton;
